import React, { useState } from 'react'
import {
  Box,
  Typography,
  Button,
  TextField,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material'

const VoucherApprovalsTable = ({ voucher, onApprove }: any) => {
  const [comments, setComments] = useState<{ [approvalId: string]: string }>({})

  const handleCommentChange = (approvalId: string, value: string) => {
    setComments((prev) => ({
      ...prev,
      [approvalId]: value,
    }))
  }

  const approvals = [...voucher.voucher_approvals].sort(
    (a, b) => a.order_number - b.order_number
  )

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Approval Stages
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Stage</TableCell>
            <TableCell>Approver</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Comment</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {approvals.map((a: any) => (
            <TableRow key={a.id}>
              <TableCell>{a.approver.user_role.name}</TableCell>
              <TableCell>{a.approver.email}</TableCell>
              <TableCell>{a.status}</TableCell>
              <TableCell>{a.comment || '-'}</TableCell>
              <TableCell>
                {a.status === 'PENDING' && (
                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                    <TextField
                      size="small"
                      placeholder="Comment"
                      value={comments[a.id] || ''}
                      onChange={(e) =>
                        handleCommentChange(a.id, e.target.value)
                      }
                    />
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() =>
                        onApprove(
                          voucher.id,
                          a.approval_stage.id,
                          comments[a.id] || '',
                          a.approval_stage.is_payment_stage
                        )
                      }
                    >
                      {a.approval_stage.is_payment_stage
                        ? 'Mark as Paid'
                        : 'Approve'}
                    </Button>
                  </Box>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  )
}

export default VoucherApprovalsTable
